import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { initializeWebConfig } from "./env";
import "./styles.css";

// アプリ起動時にランタイム config をロードしてから React をマウントする。
// ライトモード固定のため、ColorScheme の動的切り替えは行わない。
async function bootstrap(): Promise<void> {
  await initializeWebConfig();
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("#root 要素が見つかりません");
  }
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap();
